/**
 * Limpia hrefs que llegan contaminados con residuos de escapes literales
 * (`\n`, `\\n`, `//n`, `\r`, `\t`) o puntuación/paréntesis del texto que
 * los motores de autolink (marked, regex del backend) arrastran al href.
 *
 * Ejemplo real: `...ley_1934_2018.html)//n` → `...ley_1934_2018.html`
 */
const TRAILING_PUNCT = new Set(['.', ',', ';', ':', '!', '?', '"', "'", '`']);

const OPENERS: Record<string, string> = {
  ')': '(',
  ']': '[',
  '}': '{',
  '>': '<',
};

export function sanitizeUrl(raw: string | null | undefined): string {
  if (!raw) return '';

  let url = String(raw).trim();

  // Corta en el primer residuo de escape: un `\` crudo o `//n` nunca son
  // parte de una URL válida, y todo lo que sigue es texto pegado.
  url = url.split(/\\+[rnt]/i)[0];
  url = url.split(/\/\/n/i)[0];
  url = url.trim();

  // Puntuación final simple
  while (url && TRAILING_PUNCT.has(url.slice(-1))) {
    url = url.slice(0, -1);
  }

  // Cierres sin apertura: recorta solo si el balance queda negativo,
  // preservando URLs legítimas con paréntesis (p. ej. Wikipedia).
  for (;;) {
    const last = url.slice(-1);
    const opener = OPENERS[last];
    if (!opener) break;
    const closes = url.split(last).length - 1;
    const opens = url.split(opener).length - 1;
    if (closes > opens) {
      url = url.slice(0, -1);
    } else {
      break;
    }
  }

  return url;
}
